import styled from 'styled-components'

export const PointerContainer = styled.div`
  position: relative;
  width: 100px;
  margin: 10px 0px;
`
